<template>
	<div>
		<div class="history__controls">
			<chevron-left-icon size="1.5x" class="history__controls__button" @click="changeDate(-1)"></chevron-left-icon>
			<span class="history__controls__date">{{ formatDate(dateStart) }}</span>
			<chevron-right-icon size="1.5x" :class="[ 'history__controls__button', { 'history__controls__button--disabled' : isNextDate() } ]" @click="!isNextDate() && changeDate(1)"></chevron-right-icon>
		</div>
		<ul class="history__list" v-if="activityHistory.length > 0">
			<li
				v-for="(event, index) in activityHistory"
				:key="index"
				:class="'history__item' + (event.topic_id === 'KHUON_MAT_1' ? ' history__item--isIn' : ' history__item--isOut')"
			>
				<span class="history__time">{{ formatDetectTime(event.detect_time) }}</span>
				<span class="history__message">
				  {{ getEventMessage(event) }}
				</span>
			</li>
		</ul>
		<div v-else class="text-center">
			{{ $t('NoData') }}
		</div>
	</div>
</template>

<script>
import axios from "axios";
import { ChevronLeftIcon, ChevronRightIcon } from 'vue-feather-icons';

export default {
	name: "ActivityHistory",
	props: {
		personId: {
			type: String,
			required: true,
			default: "",
		},
	},
	components: {
		ChevronLeftIcon,
		ChevronRightIcon,
	},
	data() {
		const today = new Date();
		return {
			activityHistory: [],
			dateStart: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
			dateEnd: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1, 0, 0, 0),
		};
	},
	computed: {
	},
	methods: {
		isNextDate() {
			const today = new Date();
			today.setDate(today.getDate());
			return this.dateEnd >= today;
		},
		formatDate(date) {
			return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
		},
		formatAPIDate(date) {
			return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
				date.getDate()
			).padStart(2, "0")} 00:00:00`;
		},
		formatDetectTime(detectTime) {
			const date = new Date(detectTime);
			date.setHours(date.getHours() - 7); // Chuyển từ GMT sang UTC+7
			const formattedDate = date.toLocaleString("vi-VN", {
				hour: "2-digit",
				minute: "2-digit",
				second: "2-digit",
			});
			return formattedDate.replace(", ", " ");
		},
		getEventMessage(event) {
			if (event.person_name === null) {
				if (event.topic_id === "KHUON_MAT_1") {
					return `Có người lạ đi vào KTX`;
				} else if (event.topic_id === "KHUON_MAT_2") {
					return `Có người lạ đi ra KTX`;
				}
			}
			if (event.topic_id === "KHUON_MAT_1") {
				return `${event.person_name} đã đi vào KTX`;
			} else if (event.topic_id === "KHUON_MAT_2") {
				return `${event.person_name} đã đi ra KTX`;
			}
			return "Thông tin không xác định";
		},
		async getActivityHistory() {
			try {
				const response = await axios.post(
					"https://canhbaosom.com/ktx-camera-api",
					{
						url: "https://api-vms.tuila1freelancer.com/events",
						params: {
							EventType: "Face",
							IsInRoi: true,
							DateStart: this.formatAPIDate(this.dateStart),
							DateEnd: this.formatAPIDate(this.dateEnd),
							StartIndex: 0,
							EndIndex: 100,
							HourOffset: 7,
							SortBy: "time",
							SortDirection: "desc",
							PersonID: this.personId,
						}
					},
				);
				this.activityHistory = response.data.Records || [];
			} catch (error) {
				console.error("Error fetching activity history:", error);
			}
		},
		changeDate(dayOffset) {
			this.dateStart.setDate(this.dateStart.getDate() + dayOffset);
			this.dateEnd.setDate(this.dateEnd.getDate() + dayOffset);
			this.getActivityHistory();
		},
	},
	async created() {
		await this.getActivityHistory();
	},
};
</script>

<style lang="scss">
.history {
	&__controls {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 10px auto 20px;
		gap: 1rem;
		&__button{
			display: flex;
			justify-content: center;
			align-items: center;
			border: 2px solid #000000;
			color: #000000;
			border-radius: 50%;
			cursor: pointer;
			width: 21px;
			height: 21px;
			&--disabled {
				border-color: #cccccc;
				color: #cccccc;
				cursor: not-allowed;
			}
			&:hover {
				opacity: 0.8;
			}
		}
		&__date {
			font-size: 1.25rem;
			font-weight: 700;
			color: #111827;
		}
	}
	&__list {
		padding: 0;
		display: flex;
		flex-direction: column;
		gap: 15px;
	}
	&__item {
		display: flex;
		flex-direction: column;
		padding-left: 1rem;
		border-radius: 0.25rem;
		&--isIn {
			border-left: #0ca25a 5px solid;
		}
		&--isOut {
			border-left: #fb0000 5px solid;
		}
	}
	&__time {
		font-size: 1rem;
		font-weight: 700;
		color: #6b7280;
	}
	&__message {
		font-size: 1.25rem;
		font-weight: 500;
		color: #111827;
	}
}
</style>
